const baseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const assetVersion =
  process.env.REACT_APP_ASSET_VERSION ||
  process.env.REACT_APP_GIT_SHA ||
  process.env.REACT_APP_COMMIT_SHA ||
  '';

const normalizePath = (path = '') => (path.startsWith('/') ? path : `/${path}`);

const assetPath = (path) => {
  const normalized = normalizePath(path);
  if (!assetVersion) {
    return `${baseUrl}${normalized}`;
  }

  const joiner = normalized.includes('?') ? '&' : '?';
  return `${baseUrl}${normalized}${joiner}v=${assetVersion}`;
};

export default assetPath;
